module.exports = __webpack_public_path__ + "static/img/websitebg.0e9bdf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/websitestated/websitebg.png
// module id = CeQ1
// module chunks = 44